import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/Home.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';


import blenderCommissionPublicKey from '../blenderData/blenderCommissionPublicKey.js';
import blenderTransfersToPublicKey from '../blenderData/blenderTransfersToPublicKey.js';
import { Chart } from 'react-google-charts';
import {isMobile} from 'react-device-detect';

import {
  LineChart,
  Bar,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend
} from "recharts";
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import {
  PutObjectCommand,
  S3Client,
} from "@aws-sdk/client-s3";

import awsconfig from '../aws-exports.js';
import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import { 
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  Input,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
import axios from 'axios';
import SubscriptionPlanMobileRender from './subscriptionPlan/SubscriptionPlanMobileRender.jsx';
import SubscriptionPlanDesktopRender from './subscriptionPlan/SubscriptionPlanDesktopRender.jsx';


const fileDialog = require('file-dialog')

const Web3 = require('web3');

var web3;

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');


AWS.config.update({region:'us-east-1'});

const secretName = "PrivateBlenderKeys"
const region = 'us-east-1'

Amplify.configure(awsconfig);
Auth.configure(awsconfig);
Storage.configure(awsconfig);


var cognitoID;

var that; 
let primaryDisplayCurrency;
let secondaryDisplayCurrency;
var corporateBackedUsernamesArray;

var transactionValue;
var publicKey
var fundWalletPromptDidBool = false;

var emailAddress
var managerDisplay;

var actionText;
var costText;
var buttonText;
var currentUser;
var managerUsername;
var buttonColorFlashIntervalDefault;
let firstName;
let lastName;

var isSubscribedCurrentBool = false;
let initialSubscriberBoolStatus = 'unset';

var primaryLanguage;
var mode_light_dark;


var currentUser;
var currentUserCap;









let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}


class SubscriptionPlanComponent extends Component {

  constructor() {
      super()


      this.state = {
        xCoor: 170,
        yCoor: 50,
        xLine: 170,
        yValue: '-',
        xValue: '-',
        trigger: '',
        status: '',
        chartData: [0],
        values: [0],
        walletBalance: '-',
        lastEquityValue: '-',
        chartDayRange: 365 * 3,
        showOverlay: false,
        primaryDisplayPrice: 0,
        secondaryDisplayPrice: 0,
        primaryDisplayCurrency: ' ',
        secondaryDisplayCurrency: ' ',
        forexJSON: null,
        compoundedDebtSum: '-',
        currentLentSum: '-',
        timeRangeButton_1W: 'rgba(41, 43, 43, 0.8)',
        timeRangeButton_1M: 'rgba(41, 43, 43, 0.8)',
        timeRangeButton_3M: 'rgba(41, 43, 43, 0.8)',
        timeRangeButton_1Y: 'rgba(41, 43, 43, 0.8)',
        timeRangeButton_3Y: 'rgba(0, 158, 129, 1)',
        leavingTutorialOverlay: false,
        exitCountDownNumber: 3,
        noAccountsWarning_creditLine: null,
        noAccountsWarning_loanAgreement: null,
        directionsOverlay: false,
        flashButtonBorderColor: 'rgba(0, 158, 129, 1)',
        flashButtonBackgroundColor: 'rgba(41, 43, 43, 0.04)',
        flashButtonTextColor: 'rgba(0, 158, 129, 1)',
        verifyIDOverlay: false,
        fundWalletPromptOverlay: false,
        promoFundingAmountUSD: '',
        switchContractTypeView: 'creditLine',
        forceVerifyIDOverlay: false,
        verificationPeriodOverlay: false,
        downloadFormOverlay: false,
        contactReviewTeamOverlay: false,
        uploadDocumentOverlay: false,
        documentTitle: null,
        documentDetails: null,
        emailAddress: null,
        firstNameFormatted: null,
        requestedAwaitingDocumentKeyMapList: [],
        messageLineArray: [],
        foundDueDocumentBool: true,
        currentUserProfilePicture: null,
        mustSubcriberOverlay: false,
        subscriberBenefitsArray: [
          { itemIndex: 0, benefitTitleEnglish: 'AI Financial Insights', benefitTitleSpanish: 'Análisis financiero con IA', iconNameWeb: 'brain' },
          { itemIndex: 1, benefitTitleEnglish: 'Daily Activity Digest', benefitTitleSpanish: 'Resumen diario de actividad', iconNameWeb: 'calendar' },
          { itemIndex: 2, benefitTitleEnglish: 'Monthly Financial Report', benefitTitleSpanish: 'Informe financiero mensual', iconNameWeb: 'chart bar' },
          { itemIndex: 3, benefitTitleEnglish: 'Priority Support', benefitTitleSpanish: 'Soporte prioritario', iconNameWeb: 'headphones' }
        ],
        fullInvoiceArray: [],
        selectedLanguage: null,
        isSubscribedCurrentBool: false,
        showSubscribedVisitModal: false,
        cancelSubscriptionConfirmationOverlay: false,
        disableButtons: false,
        contactReviewTeamOverlay: false,
        messageToReviewTeamString: null,
        successfulPaymentOverlay: false,
        successfulNewSubscriptionOverlay: false,
        successfulDocumentUploadOverlay: false,
        selectedLanguage: null,
        mode_light_dark: null,
        currentUser: null,
        errorTags: null,
        lastBenefitItemIndexScrolled: 0
                   }

      that = this

      
      

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));


      trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
        currentUser = res.username
        cognitoID = res.signInUserSession.idToken.jwtToken


      })
  }
















  componentDidMount(){

    if(isMobile){
      // window.open("https://lenderblockcorp.com/blenderplatform","_self")
    }
  
    that.setState({
      selectedLanguage: localStorage.getItem('primaryLanguage'),
      mode_light_dark: localStorage.getItem('mode_light_dark'),
      errorTags: null,
      lastBenefitItemIndexScrolled: 0,
    })


    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username
      cognitoID = res.signInUserSession.idToken.jwtToken


      that.setState({
        currentUser
      })


      let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

      that.setState({
        currentUserProfilePicture: profilePicture_uri
      })

      Storage.get(
        `${currentUser.toLowerCase()}/profilePicture.jpg`,
        {
            bucket: "platform-user-media-uploads",
            level: "public"
        }
      ).then((res) => {
        trackPageRequest(fetch(
          res
        )).then((image) => {
          if(image.status == 200){
            profilePicture_uri = res;
          }
          that.setState({
            currentUserProfilePicture: profilePicture_uri
          })
        })
      })


      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: String(currentUser), 
          requestOperation: 'get',
        }
      }).then((userData) => {

        
        

        this.refreshBlenderMembership().catch(() => {
          // Preserve inactive state on membership API failures rather than trusting stale user flags.
          this.setState({ isSubscribedCurrentBool: false });
        });
      }).catch((err) => {

      })



      that.initialMountComponents()
      that.setState({
        exitCountDownNumber: 3,
        flashButtonBorderColor: 'rgba(0, 158, 129, 1)',
        flashButtonBackgroundColor: 'rgba(41, 43, 43, 0.04)',
        flashButtonTextColor: 'rgba(0, 158, 129, 1)',
        verifyIDOverlay: false,
        fundWalletPromptOverlay: false,
        mustSubcriberOverlay: false,
        forceVerifyIDOverlay: false,
        cancelSubscriptionConfirmationOverlay: false,
        verificationPeriodOverlay: false,
        downloadFormOverlay: false,
        contactReviewTeamOverlay: false,
        uploadDocumentOverlay: false,
        documentTitle: null,
        documentDetails: null,
        emailAddress: null,
        firstNameFormatted: null,
        messageToReviewTeamString: null,
        disableButtons: false,
        successfulDocumentUploadOverlay: false
                    })
      clearInterval(buttonColorFlashIntervalDefault);
    })
  }

  componentWillUnmount() {
  }

  


  initialMountComponents(){

    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {


      currentUser = res.username
      cognitoID = res.signInUserSession.idToken.jwtToken

      currentUserCap = currentUser.toUpperCase()
      if(currentUserCap.length > 10){
        currentUserCap =  currentUserCap.substr(0, 9).concat(' ...')
      }
      that.setState({ currentUser })
      
      let isSubscribedCurrentBool = false;
      
      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'users', 
          primaryKey: String(currentUser), 
          requestOperation: 'get',
        }
      }).then((userData) => {
        primaryDisplayCurrency = userData.Item.preferences.primaryDisplayCurrency
        secondaryDisplayCurrency = userData.Item.preferences.secondaryDisplayCurrency
        publicKey = userData.Item.publicKey
        emailAddress = userData.Item.emailAddress
        firstName = userData.Item.firstName
        lastName = userData.Item.lastName

        let firstNameFormatted = firstName.substr(0,1).concat(firstName.substr(1,firstName.length-1))
        let lastNameFormatted = lastName.substr(0,1).concat(lastName.substr(1,lastName.length-1))


        
        

        

        that.setState({})

        authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'platformConfigurations', 
              primaryKey: 'BlenderProPlusBenefits', 
              requestOperation: 'get',
            }
        }).then((userData) => {

            let subscriberBenefitsArray = userData?.Item?.BlenderProPlusBenefits
            if (Array.isArray(subscriberBenefitsArray) && subscriberBenefitsArray.length) {
              that.setState({ subscriberBenefitsArray }, () => that.scrollBenefits(0));
            }
            
            

        })



        this.refreshBlenderMembership().catch(() => {
          // Preserve inactive state on membership API failures rather than trusting stale user flags.
          this.setState({ isSubscribedCurrentBool: false });
        });

        let fullInvoiceArray = []
        that.setState({ fullInvoiceArray: [], disableButtons: false });

        that.setState({
          emailAddress,
          firstNameFormatted,
          lastNameFormatted,
          memberPdfProfile: {
            fullName: [firstName, lastName].filter(Boolean).join(' ').trim(),
            username: currentUser || '',
            address: (() => {
              const item = userData?.Item || {};
              const candidate = item.mailingAddress || item.postalAddress || item.address || item.streetAddress;
              if (typeof candidate === 'string') return candidate;
              if (candidate && typeof candidate === 'object') {
                return [candidate.line1 || candidate.addressLine1 || candidate.street, candidate.line2 || candidate.addressLine2,
                  candidate.city, candidate.state || candidate.region, candidate.postalCode || candidate.zipCode, candidate.country]
                  .filter(Boolean).join(', ');
              }
              return [item.addressLine1, item.addressLine2, item.city, item.state, item.zipCode || item.postalCode, item.country]
                .filter(Boolean).join(', ');
            })(),
            dateJoined: (() => {
              const item = userData?.Item || {};
              const raw = item.dateJoined || item.joinedAt || item.createdAt || item.creationDate || item.dateCreated;
              if (raw == null || raw === '') return '';
              const parsed = typeof raw === 'number'
                ? new Date(raw < 1e11 ? raw * 1000 : raw)
                : new Date(raw);
              return Number.isNaN(parsed.getTime()) ? String(raw) : parsed.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
            })()
          },
          requestedAwaitingDocumentKeyMapList: [],
          messageLineArray: [],
          foundDueDocumentBool: true
                      })



        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'verifiedRegistryApplications', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then((verifiedRegistryApplications) => {
          let requestedAwaitingDocumentKeyMapList = []
          let messageLineArray = verifiedRegistryApplications.Item.messageLineArray
          let requestedAwaitingDocumentKeyObjects = verifiedRegistryApplications.Item.requestedAwaitingDocumentKeyObjects
          let requestedAwaitingDocumentKeyArray = verifiedRegistryApplications.Item.requestedAwaitingDocumentKeyArray
          let foundDueDocumentBool = false
          
          for(let d=0; d<=requestedAwaitingDocumentKeyArray.length-1; d++){
            let documentDetails;

            let isAcceptedSubmissionStatus = requestedAwaitingDocumentKeyObjects[requestedAwaitingDocumentKeyArray[d]].documentSatisfiedBool

            if(that.state.selectedLanguage == 'spanish'){
              if(requestedAwaitingDocumentKeyArray[d] == 'Proof of Address'){
                documentDetails = 'Comprobante de domicilio en forma de últimas facturas de servicios públicos o contrato de alquiler actual'
                requestedAwaitingDocumentKeyArray[d] = 'Comprobante de Domicilio'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 1 (Back)'){
                documentDetails = 'Comprobante de identidad en forma de identificación con fotografía emitida por el gobierno federal o estatal'
                requestedAwaitingDocumentKeyArray[d] = 'Comprobante de Identidad 1 (del reverso)'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 1 (Front)'){
                documentDetails = 'Comprobante de identidad en forma de identificación con fotografía emitida por el gobierno federal o estatal'
                requestedAwaitingDocumentKeyArray[d] = 'Comprobante de Identidad 1 (del frente)'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 2'){
                documentDetails = 'Comprobante de identidad en forma de certificado de nacimiento de EE. UU., pasaporte, identificación real o tarjeta de residente permanente de EE. UU.'
                requestedAwaitingDocumentKeyArray[d] = 'Prueba de Identidad 2'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Income 1'){
                documentDetails = 'Comprobante de ingresos recurrentes en forma de uno de sus dos recibos de sueldo más recientes'
                requestedAwaitingDocumentKeyArray[d] = 'Comprobante de Ingresos 1'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Income 2'){
                documentDetails = 'Comprobante de ingresos recurrentes en forma de uno de sus dos recibos de sueldo más recientes'
                requestedAwaitingDocumentKeyArray[d] = 'Comprobante de Ingresos 2'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Verified Registry Application Form'){
                documentDetails = 'Solicitar y completar el formulario de Blender Verified Registry.'
                requestedAwaitingDocumentKeyArray[d] = 'Formulario de Solicitud de Verified Registry'
              }
            } else {
              if(requestedAwaitingDocumentKeyArray[d] == 'Proof of Address'){
                documentDetails = 'Proof of Address in form of Latest Utility Bills or Current Rental Contract'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 1 (Back)'){
                documentDetails = 'Proof of Identity in form of federal or state issued photo identification'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 1 (Front)'){
                documentDetails = 'Proof of Identity in form of federal or state issued photo identification'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Identity 2'){
                documentDetails = 'Proof of Identity in form of US Birth Certificate, Passport, Real ID, or US Permanent Resident Card'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Income 1'){
                documentDetails = 'Proof of Recurring Income in form of one of your two most recent paystubs'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Proof of Income 2'){
                documentDetails = 'Proof of Recurring Income in form of one of your two most recent paystubs'
              } else if (requestedAwaitingDocumentKeyArray[d] == 'Verified Registry Application Form'){
                documentDetails = 'Request and Complete the VR Application Form'
              }
            }
            requestedAwaitingDocumentKeyMapList.push({
              documentName: requestedAwaitingDocumentKeyArray[d],
              documentDetails,
              id: String(requestedAwaitingDocumentKeyMapList.length),
              isAcceptedSubmissionStatus,
            })

            if(isAcceptedSubmissionStatus){
              foundDueDocumentBool = true
            }

            if(requestedAwaitingDocumentKeyMapList.length == requestedAwaitingDocumentKeyArray.length){
              that.setState({
                requestedAwaitingDocumentKeyMapList,
                messageLineArray: messageLineArray,
                foundDueDocumentBool
              })
            }
          }

          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
              category: 'db',
              tableName: 'platformConfigurations', 
              primaryKey: 'corporateBackedUsernamesArray', 
              requestOperation: 'get',
            }
          }).then((_corporateBackedUsernamesArray) => {
            corporateBackedUsernamesArray = _corporateBackedUsernamesArray.Item.corporateBackedUsernamesArray
          })

          
          that.setState({
            primaryDisplayCurrency,
            secondaryDisplayCurrency,
          })

        })
      })
    });
  }

  // Cognito ID tokens remain in use for the legacy Blender API. The membership
  // Lambda requires an access token from the very same authenticated session.
  async getMembershipIdentity() {
    const session = await Auth.currentSession();
    const token = session.getAccessToken();
    const accessToken = token.getJwtToken();
    const userId = token.payload && token.payload.sub;
    if (!accessToken || !userId) throw new Error('Please sign in again to manage your subscription.');
    return { accessToken, userId };
  }

  async refreshBlenderMembership() {
    const { accessToken } = await this.getMembershipIdentity();
    const response = await fetch('https://ivevzjrqzs3z3fasduidlmeyqq0cntfs.lambda-url.us-east-1.on.aws/membership', {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}`, Accept: 'application/json' },
      cache: 'no-store'
    });
    const data = await response.json();
    if (!response.ok || !data.success) throw new Error(data.error || 'Could not check subscription status.');
    // No fallback to the old user-table boolean after a successful AWS response.
    isSubscribedCurrentBool = data.hasAccess === true;
    initialSubscriberBoolStatus = isSubscribedCurrentBool;
    const showSubscribedVisitModal = isSubscribedCurrentBool && !this._subscribedModalShownThisVisit;
    if (showSubscribedVisitModal) this._subscribedModalShownThisVisit = true;
    this.setState({ isSubscribedCurrentBool, membership: data, disableButtons: false, ...(showSubscribedVisitModal ? { showSubscribedVisitModal: true } : {}) });
    return data;
  }

  async onPayPalSubscriptionApproved(subscriptionId) {
    this.setState({ disableButtons: true });
    try {
      if (!/^I-[A-Za-z0-9-]{5,100}$/.test(String(subscriptionId || ''))) {
        throw new Error('PayPal did not return a valid subscription ID.');
      }
      const { accessToken } = await this.getMembershipIdentity();
      const response = await fetch('https://ivevzjrqzs3z3fasduidlmeyqq0cntfs.lambda-url.us-east-1.on.aws/membership/link', {
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ provider: 'paypal', subscriptionId })
      });
      const result = await response.json();
      if (!response.ok || !result.success) throw new Error(result.error || 'Subscription verification is pending.');
      const membership = await this.refreshBlenderMembership();
      if (!membership.hasAccess) throw new Error('PayPal approved checkout, but membership is not active yet.');
      this.setState({ successfulNewSubscriptionOverlay: true, successfulPaymentOverlay: true });
      return result;
    } catch (error) {
      this.setNativeNotification(this.state.selectedLanguage === 'spanish'
        ? 'PayPal aprobó el proceso, pero aún no se confirmó la suscripción. ' + error.message
        : 'PayPal checkout completed, but subscription verification is not confirmed. ' + error.message);
      throw error;
    } finally {
      this.setState({ disableButtons: false });
    }
  }

  subscribeNewMember(){
    that.setState({ disableButtons: false, pendingTransactionLoaderOverlay: false });
    that.setNativeNotification(that.state.selectedLanguage == 'spanish'
      ? 'La Facturación de Suscripciones No Está Disponible Actualmente.'
      : 'Subscription Billing Is Currently Unavailable.');
  }

  initiateSubscriptionCancelation(){
    that.setState({ disableButtons: false, pendingTransactionLoaderOverlay: false });
    that.setNativeNotification(that.state.selectedLanguage == 'spanish'
      ? 'La Facturación de Suscripciones No Está Disponible Actualmente.'
      : 'Subscription Billing Is Currently Unavailable.');
  }

  sendMessageToReviewTeam(messageToReviewTeamString){
    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
          category: 'db',
          tableName: 'verifiedRegistryApplications', 
          primaryKey: currentUser,
          requestOperation: 'update',
          updateExpression: 
            `SET 
              messageLineArray = list_append(messageLineArray, :messageLineArrayItem)
            `,
          expressionAttributeValues: { 
            ':messageLineArrayItem': [{
              messageText: String(messageToReviewTeamString),
              senderUsername: currentUser.toLowerCase(),
              timestamp: String(new Date())
            }],
          },
      }
    }).then((res) => {

      authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
          category: 'db',
          tableName: 'general', 
          primaryKey: 'orderedPendingVerifiedRegistryApplicants', 
          requestOperation: 'get',
        }
      }).then((_orderedPendingVerifiedRegistryApplicants) => {

        let orderedPendingVerifiedRegistryApplicants = _orderedPendingVerifiedRegistryApplicants.Item.orderedPendingVerifiedRegistryApplicants;
        if(!orderedPendingVerifiedRegistryApplicants.includes(currentUser)){


          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
                category: 'db',
                tableName: 'general', 
                primaryKey: 'orderedPendingVerifiedRegistryApplicants',
                requestOperation: 'update',
                updateExpression: 
                  `SET 
                    orderedPendingVerifiedRegistryApplicants = list_append(orderedPendingVerifiedRegistryApplicants, :orderedPendingVerifiedRegistryApplicants)
                  `,
                expressionAttributeValues: { 
                  ':orderedPendingVerifiedRegistryApplicants': [currentUser],
                },
            }
          }).then((res) => {

            that.initialMountComponents()

          })

        }

      })
      

        authenticatedPut('api1169ba1e', '', { 
          headers: { Authorization: `Bearer ${cognitoID}` },
          body: { 
            category: 'db',
            tableName: 'verifiedRegistryApplications', 
            primaryKey: currentUser, 
            requestOperation: 'get',
          }
        }).then((verifiedRegistryApplications) => {

          let messageLineArray = verifiedRegistryApplications.Item.messageLineArray
        
          that.setState({
            messageLineArray: messageLineArray,
            messageToReviewTeamString: '',  
          })
          

        })
      })
  }

  sendFormViaEmail(emailAddress, firstNameFormatted){
    const s3 = new AWS.S3();

    var getS3Params1 = {
      Bucket: 'public-verified-member-registry',                           
      Key: 'TBP_VerifiedRegistryApplicationForm.pdf'
   }

   s3.getObject(getS3Params1, async function(err, data) {
      let objectBuffer = data.Body
   
      const blob = new Blob([objectBuffer]);
                         
      const url = window.URL.createObjectURL(blob);
      
      const a = document.createElement("a");

      document.body.appendChild(a);

      a.style = "display: none";

      a.href = url;

      a.download = "filename.pdf";

      a.click();

      window.URL.revokeObjectURL(url);



      // let fileContentString = String(`attachment ;filename="The Blender Platform Verified Registry Form.pdf"`)
      // attachmentEntity.header('Content-Disposition', fileContentString);

      // mailContent_signer.body.push(attachmentEntity);

      // ses.sendRawEmail({
      //   Destinations: [emailAddress],
      //   RawMessage: {
      //       Data: mailContent_signer.toString() 
      //   },
      //   Source: 'admin@theblenderplatform.io', // Must be verified within AWS SE
      // }, (res) => {
      
      // })
    
    })
  }


  uploadNewVRDocument(documentName){
    fileDialog({ 
      multiple: false, 
      accept: ['image/*', 'application/pdf'] 
    }).then(file => {
        const data = new FormData()
        data.append('file', file[0])

        
          const reader = new FileReader();
      
          reader.onload = (e) => {
            const uri = e.target.result;


            trackPageRequest(axios.get(uri, { responseType: 'arraybuffer' })).then((res) => {                                                          

                let fileBody = res.data
                let fileKey = String(`${Date.now()}___${that.state.currentUser}`)
                let fileType = file[0].type
                let fileName = String(`${that.state.currentUser}/${fileKey}`);

                authenticatedPut('api1169ba1e', '', { 
                  headers: { Authorization: `Bearer ${cognitoID}` },
                  body: { 
                      category: 'db',
                      tableName: 'verifiedRegistryApplications', 
                      primaryKey: that.state.currentUser,
                      requestOperation: 'update',
                      updateExpression: 
                        `SET allDocumentFileIDs = list_append(allDocumentFileIDs, :fileKey)`,
                      expressionAttributeValues: { 
                        ':fileKey': [fileKey],
                      },
                  }
                }).then((res) => {
                })


            })

          };
      
          reader.readAsDataURL(file[0]);  
          
    })

  }

  scrollBenefits(_id){
    let id = _id;
    if(id < 1 && that.state.lastBenefitItemIndexScrolled < id){
      id = 1
    } else if(id > that.state.subscriberBenefitsArray.length-2 && that.state.lastBenefitItemIndexScrolled > id){
      id = that.state.subscriberBenefitsArray.length-2
    } else if(id > that.state.subscriberBenefitsArray.length-1){
      // id = 0;
    } else if (id < 0){
      // id = that.state.subscriberBenefitsArray.length-1
    }

    const element = document.getElementById(id);
    if (element) {
      that.setState({
        lastBenefitItemIndexScrolled: id
      })
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', });
    }
  }

  setNativeNotification(generalNoticeText){
    that.setState({
      generalNoticeOverlay: true,
      generalNoticeText
    })
  }

  render(){
    


      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { getMembershipIdentity: this.getMembershipIdentity.bind(this), onPayPalSubscriptionApproved: this.onPayPalSubscriptionApproved.bind(this), refreshBlenderMembership: this.refreshBlenderMembership.bind(this), API, AWS, Amplify, Auth, Bar, Button, ButtonContent, ButtonGroup, CartesianGrid, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, Input, LENDERBLOCKADMINWHITELIST, Legend, Line, LineChart, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PutObjectCommand, Radio, React, ResponsiveContainer, S3Client, Storage, SubscriptionPlan, ThreeDot, Tooltip, Web3, XAxis, YAxis, actionText, awsconfig, axios, blenderCommissionPublicKey, blenderPrivateKey, blenderTransfersToPublicKey, buttonColorFlashIntervalDefault, buttonText, checkValidAuthTokenIntervalPeriod_ms, cognitoID, corporateBackedUsernamesArray, costText, currentUser, currentUserCap, emailAddress, ethers, fileDialog, firstName, fundWalletPromptDidBool, initialSubscriberBoolStatus, isMobile, isSubscribedCurrentBool, lastName, managerDisplay, managerUsername, mimemessage, mode_light_dark, monthLengtheningEnum, navigationHandler, primaryDisplayCurrency, primaryLanguage, publicKey, region, routeProps, secondaryDisplayCurrency, secretName, that, tokenLifeTimeLimit, transactionValue, useLayoutEffect, useParams, useRef, web3 };

      if (isMobile) {
        return <SubscriptionPlanMobileRender {...renderProps} />;
      }

      return <SubscriptionPlanDesktopRender {...renderProps} />;
    }





}


function SubscriptionPlan(){

  return (<SubscriptionPlanComponent/>)
}

export default SubscriptionPlan;

